import React from "react"
import PropTypes from "prop-types"
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined"
import { ReactComponent as MaterialIcon } from "assets/customIcons/materiales.svg"
import { ReactComponent as ManodeobraIcon } from "assets/customIcons/manodeobra.svg"
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined"
import RecyclingIcon from "@mui/icons-material/Recycling"
import AutoDeleteOutlinedIcon from "@mui/icons-material/AutoDeleteOutlined"
import { HelveticaBold } from "common/typographies.js"
import { DeleteOutline } from "@mui/icons-material"
import { calcularImporteDeDescomposicion, getCurrency } from "utils/functions"

const baseTextStyle = {
  color: "#414141",
  fontWeight: "300",
  fontFamily: "Helvetica",
  fontSize: "14px",
  paddingRight: "10px",
}

const getIconForType = type => {
  const iconStyle = {
    width: "20px",
    height: "20px",
    marginLeft: "1px",
    color: "#c4c4c4",
  }

  switch (type) {
    case "coste":
      return <MonetizationOnOutlinedIcon style={iconStyle} />
    case "material":
      return <MaterialIcon style={{ marginTop: "-1px" }} />
    case "manodeobra":
      return <ManodeobraIcon style={{ marginTop: "-1px" }} />
    case "maquinaria":
      return <LocalShippingOutlinedIcon style={iconStyle} />
    case "residuoAdicional":
      return <RecyclingIcon style={iconStyle} />
    case "residuoClasificacion":
      return <AutoDeleteOutlinedIcon style={iconStyle} />
    default:
      return <ManodeobraIcon style={{ marginTop: "-1px" }} />
  }
}

const DetailView = ({ detail, index, user, setEditMode, deleteDetail }) => {
  const totalCalculated = calcularImporteDeDescomposicion(detail)
  const currency = getCurrency(user["custom:currency"])

  const formatPrice = (price, unity) => {
    const formatted = parseFloat(price).toFixed(2)
    if (unity === "%") return `${formatted} ${currency}`
    if (price > 0 && unity) return `${formatted} ${currency}/${unity}`
    return `${formatted} ${currency}`
  }

  return (
    <div
      id="rowHoverNoColor"
      onDoubleClick={() => setEditMode(true)}
      className="inline"
      style={{ width: "100%" }}
    >
      {/* Icon */}
      <div
        style={{
          marginBottom: "1rem",
          width: "8%",
          textAlign: "center",
          paddingRight: "15px",
        }}
      >
        {getIconForType(detail.type)}
      </div>

      {/* Description */}
      <div style={{ width: "48%", textAlign: "start" }}>
        <HelveticaBold style={{ ...baseTextStyle, overflowWrap: "break-word" }}>
          {detail.description}
        </HelveticaBold>
      </div>

      {/* Quantity */}
      <div style={{ width: "13%", textAlign: "right" }}>
        <HelveticaBold style={baseTextStyle}>
          {detail.unity === "%"
            ? (parseFloat(detail.quantity) * 100).toFixed(2) + " %"
            : parseFloat(detail.quantity).toFixed(2) + " " + detail.unity}
        </HelveticaBold>
      </div>
      <div style={{ width: "13%", textAlign: "right" }}>
        <HelveticaBold style={baseTextStyle}>
          {formatPrice(detail.price, detail.unity)}
        </HelveticaBold>
      </div>

      {/* Total */}
      <div style={{ width: "12%", textAlign: "center" }}>
        <HelveticaBold style={{ ...baseTextStyle, textAlign: "right" }}>
          {totalCalculated + " " + currency}
        </HelveticaBold>
      </div>

      {/* Delete Button */}
      <DeleteOutline
        onClick={e => deleteDetail(e, index)}
        id="showCheckbox"
        style={{
          fontSize: "18px",
          display: "none",
          color: "#414141",
          marginTop: "1px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      />
    </div>
  )
}

DetailView.propTypes = {
  index: PropTypes.any,
  user: PropTypes.object,
  details: PropTypes.array,
  setDetails: PropTypes.func,
  detail: PropTypes.object,
  editMode: PropTypes.bool,
  setEditMode: PropTypes.func,
  deleteDetail: PropTypes.func,
}

export default DetailView
